import { render, staticRenderFns } from "./recovery.vue?vue&type=template&id=ad7773ec&scoped=true&"
import script from "./recovery.vue?vue&type=script&lang=ts&"
export * from "./recovery.vue?vue&type=script&lang=ts&"
import style0 from "./recovery.vue?vue&type=style&index=0&id=ad7773ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad7773ec",
  null
  
)

export default component.exports